<div class="text-center">

  <mat-icon>access_time</mat-icon>
  <h1 mat-dialog-title translate>dialog.time.update.title</h1>
  
  <div class="modal-body" mat-dialog-content>
    
    <help-alert
                info        = "help.info"
                text        = "help.page.new_time.field"
                description = "help.page.new_time.description">
    </help-alert>

    <div class="card container">
      <div class="row mt-2">
        <div class="col-md">
          <mat-form-field>
            <mat-label translate>dialog.time.generic.day</mat-label>
            <mat-select [(ngModel)]="_calendar.dow" matNativeControl>
              <mat-option *ngFor="let day of days" [value]="day.dow">
                {{day.name | translate}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="card container mt-3">
      <div class="row">
        
        <div class="col-sm">
          <span translate>dialog.time.generic.open</span>
          <ngb-timepicker [(ngModel)] = "open"></ngb-timepicker>
        </div>

        <div class="col-sm">
          <span translate>dialog.time.generic.close</span>
          <ngb-timepicker [(ngModel)] = "close"></ngb-timepicker>
        </div>

      </div>
    </div>
  </div>

  <div class="modal-footer" mat-dialog-actions translate>

    <button type="button" class="btn btn-outline-danger" (click)="cancel()" translate>
      dialog.time.generic.cancel
    </button>

     <button type="button" class="btn btn-outline-secondary" (click)="create()" translate>
        dialog.time.create.confirm
      </button>
  </div>

</div>